import React from "react";
import {
  FaTwitter,
  FaGamepad,
  FaUser,
  FaCodeBranch,
  FaSignOutAlt,
  FaMedium,
  FaBookOpen,
  FaRedditAlien,
} from "react-icons/fa";

const links = [
  { icon: <FaTwitter />, label: "Twitter", url: "https://x.com/aeroscraper" },
  { icon: <FaGamepad />, label: "Discord", url: "https://discord.gg/VAJ8Ejj5Tm" },
  { icon: <FaUser />, label: "Galxe", url: "https://app.galxe.com/aeroscraper" },
  { icon: <FaCodeBranch />, label: "Zealy", url: "https://zealy.io/cw/aeroscraper/questboard" },
  { icon: <FaSignOutAlt />, label: "Guild", url: "https://guild.xyz/aeroscraper" },
  { icon: <FaMedium />, label: "Medium", url: "https://medium.com/@aeroscraper" },
  { icon: <FaBookOpen />, label: "GitBook", url: "https://novaratio.gitbook.io/aeroscraper" },
  { icon: <FaRedditAlien />, label: "Dorahacks", url: "https://dorahacks.io/buidl/7509" },
];

const Footer = () => {
  return (
    <footer className="w-full min-h-[20vh] text-white pt-8 pb-3">
      <div className="relative z-10 ">
        <div className="container mx-auto px-4 flex flex-wrap justify-center gap-6">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-16 h-16 flex flex-col items-center justify-center 
              bg-[#191919] text-white rounded-full shadow-[inset_0_2px_6px_rgba(255,255,255,0.1)] 
              cursor-pointer transition-transform duration-300 hover:scale-110"
            >
              <div className="text-xl mb-1">{link.icon}</div>
              <p className="text-[8px] font-semibold text-center">{link.label}</p>
            </a>
          ))}
        </div>
        <div className="text-center text-gray-400 mt-4 text-[8px] cursor-default">
          <p>Bridgeless Cross - Chain Hedge</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
